import React from "react";
import ResultGeneric from "./ResultGeneric.jsx";
import ResultDetailPerSubmatch from "./ResultDetailPerSubmatch.jsx";

const Result = ({result, marked, onDetailsClick, current, game}) => {
    if (!result) return null;

    let perSubmatchPart = result.parts.find(
        (part) => part.type === "result-part--places-per-submatch"
    );

    return (
        <div className="result">
            {perSubmatchPart ? (
                <ResultDetailPerSubmatch
                    title={result.title}
                    onDetailsClick={onDetailsClick}
                    details={perSubmatchPart.details}
                    marked={marked}
                />
            ) : null}
            <ResultGeneric
                onDetailsClick={onDetailsClick}
                result={result}
                marked={marked}
                current={current}
                game={game}
            />
        </div>
    );
};

export default Result;
